import type { ExposureHedgeStatus, ExposureRow } from '../api/exposure';
import { parseDecimal } from './decimal';

// View-side keys mapped from the backend hedgeStatus. The chip filter, group
// headers, and pill colors all key off these short slugs. Order matches the
// launchpad: Needs Action first (most urgent), then In Progress, Covered,
// finally No Action (which is hidden by default unless the order still has
// active hedges).
export type ExposureView = 'needs-action' | 'in-progress' | 'covered' | 'no-action';

export const VIEW_ORDER: ExposureView[] = ['needs-action', 'in-progress', 'covered', 'no-action'];

export const VIEW_LABEL: Record<ExposureView, string> = {
  'needs-action': 'Needs Action',
  'in-progress': 'In Progress',
  covered: 'Covered',
  'no-action': 'No Action',
};

const STATUS_TO_VIEW: Record<ExposureHedgeStatus, ExposureView> = {
  Unhedged: 'needs-action',
  'Partially Hedged': 'in-progress',
  'Fully Hedged': 'covered',
  'No Hedge Required': 'no-action',
};

export function statusToView(status: ExposureHedgeStatus): ExposureView {
  return STATUS_TO_VIEW[status];
}

// Total open volume across the rows is the sum of buy_unpriced + sell_unpriced
// for every Unhedged / Partially-Hedged row. Mirrors launchpad's open-volume
// KPI computation in SummaryStrip.
export function sumOpenVolumeMt(rows: readonly ExposureRow[]): number {
  let total = 0;
  for (const row of rows) {
    if (row.hedgeStatus !== 'Unhedged' && row.hedgeStatus !== 'Partially Hedged') continue;
    total += parseDecimal(row.buyUnpricedMt) + parseDecimal(row.sellUnpricedMt);
  }
  return total;
}
